export * from "./MenuColumn2"
export { default } from "./MenuColumn2"
